import { useMemo } from 'react';

import { ServiceProvidingLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { VisitLocationData, VisitLocationType } from './VisitLocation.types';
import { VisitLocationDropdown } from './VisitLocationDropdown';
import { createVisitLocation, createVisitLocationId } from './VisitLocationDropdown.utils';

type ServiceProvidingLocationDropdownProps = {
   readonly serviceProvidingLocationId: number | undefined;
   readonly serviceProvidingLocations: ServiceProvidingLocation[];
   readonly disabled: boolean;
   readonly visitId: Visit['id'];
};

export const ServiceProvidingLocationDropdown = (props: ServiceProvidingLocationDropdownProps): JSX.Element => {
   const visitLocations = useMemo(
      (): VisitLocationData[] =>
         props.serviceProvidingLocations.map(
            (serviceProvidingLocation): VisitLocationData => {
               return createVisitLocation(VisitLocationType.SERVICE_PROVIDING_LOCATION, serviceProvidingLocation);
            }
         ),
      [props.serviceProvidingLocations]
   );

   const initialVisitLocationId = useMemo(
      () => createVisitLocationId(VisitLocationType.SERVICE_PROVIDING_LOCATION, props.serviceProvidingLocationId),
      [props.serviceProvidingLocationId]
   );

   return (
      <VisitLocationDropdown
         visitLocations={visitLocations}
         visitId={props.visitId}
         initialVisitLocationId={initialVisitLocationId}
         disabled={props.disabled}
      />
   );
};
